<template>
  <div class="drive">
    <Head></Head>
    <div class="pc" v-if="isPhone==false">
      <div class="container">
        <div class="section1">
          <img alt="xxx" src="../../assets/skoda-drive/imgs/101.jpg" style="width: 100%;" />
        </div>
        <div class="section2">
          <div class="contain">
            <div class="left">
              <div class="img">
                <img alt="xxx" :src="spotImg" style="width: 100%;" />
              </div>
              <div id="spot1" class="spot1" @click="changeSpot1()"></div>
              <div id="spot2" class="spot2" @click="changeSpot2()"></div>
              <div id="spot3" class="spot3" @click="changeSpot3()"></div>
            </div>
            <div class="right">
              <div class="title">斯柯达GT双子星品评会</div>
              <div class="line"></div>
              <div
                class="text"
              >随着柯迪亚克GT、柯米克GT的相继推出，斯柯达年轻、个性化的风格特色日益突显。不久前，两位上汽大众斯柯达品牌营销事业执行总监和资深专业媒体一起，深入体验了柯迪亚克GT以及柯米克GT，这对“GT双子星”。</div>
            </div>
            <div style="clear: both;"></div>
          </div>
        </div>
        <div class="section3">
          <div class="title">
            <div class="img">
              <img alt="xxx" src="../../assets/skoda-drive/imgs/301.png" style="width:100%" />
            </div>
          </div>
          <div class="contain">
            <div class="block1">
              <div class="box1">
                <div class="left clickStyle" @click="showPopSec3(1)">
                  <img alt="xxx" src="../../assets/skoda-drive/imgs/302.png" style="width: 100%;" />
                  <div class="icon">
                    <img src="../../assets/imgs/play2.png" style="width:100%" />
                  </div>
                </div>
                <div class="right">
                  <img alt="xxx" src="../../assets/skoda-drive/imgs/3052.png" style="width: 100%;" />
                  <div class="content">
                    <div class="title">斯柯达品牌营销事业执行总监</div>
                    <div class="title2">林元航 试驾柯迪亚克GT</div>
                    <div class="line1">“</div>
                    <div
                      class="text"
                    >柯迪亚克GT兼具了轿跑SUV的外形，GT的澎湃动力，还拥有较多的同级领先的高科技配置。百公里加速只有7.5秒，油耗在7.9升。动力方面的优势相当突出。</div>
                    <div class="line2">”</div>
                  </div>
                </div>
                <div style="clear: both;"></div>
              </div>
              <div class="box2">
                <div class="left">
                  <div class="img">
                    <img alt="xxx" src="../../assets/skoda-drive/imgs/303.png" style="width: 100%;" />
                  </div>
                  <div class="content">
                    <div class="wrap">
                      <div class="title2">动感外观美出高度，更具辨识度</div>
                      <div class="line1">“</div>
                      <div class="text">侧面是这车最美的高度，这根腰线赋予了它运动的快感。</div>
                      <div class="line2">”</div>
                    </div>
                  </div>
                </div>
                <div class="right">
                  <div class="img">
                    <img alt="xxx" src="../../assets/skoda-drive/imgs/304.png" style="width: 100%;" />
                  </div>
                  <div class="content">
                    <div class="wrap">
                      <div class="title2">前脸尽显凌厉气质</div>
                      <div class="line1">“</div>
                      <div
                        class="text"
                      >前脸蜂窝状格栅保证了它的运动气质，直瀑式前格栅看起来有些悬浮，凌厉动感。这源于捷克在文化艺术、建筑上的沉淀；同时制造工艺让整个批量车的稳定性和一致性都非常强，而这些都需要不断沉淀、迭代，都无法复制。</div>
                      <div class="line2">”</div>
                    </div>
                  </div>
                </div>
                <div style="clear: both;"></div>
              </div>
              <div style="clear: both;"></div>
            </div>
            <div class="block2">
              <div class="box1">
                <div class="left">
                  <img alt="xxx" src="../../assets/skoda-drive/imgs/305.png" style="width: 100%;" />
                  <div class="content">
                    <div class="title">斯柯达品牌营销事业执行总监</div>
                    <div class="title2">安瑞格 Christoph Aringer 试驾柯米克GT</div>
                    <div class="line1">“</div>
                    <div class="text">柯米克GT是斯柯达SUV家族的最新成员，并且是在国内设计，为国内用户打造的专属车型。</div>
                    <div class="line2">”</div>
                  </div>
                </div>
                <div class="right clickStyle" @click="showPopSec3(2)">
                  <img alt="xxx" src="../../assets/skoda-drive/imgs/306.png" style="width: 100%;" />
                  <div class="icon">
                    <img src="../../assets/imgs/play2.png" style="width:100%" />
                  </div>
                </div>
                <div style="clear: both;"></div>
              </div>
              <div class="box2">
                <div class="left">
                  <div class="img">
                    <img alt="xxx" src="../../assets/skoda-drive/imgs/307.png" style="width: 100%;" />
                  </div>
                  <div class="content">
                    <div class="wrap">
                      <div class="title2">动感造型，酷炫精致</div>
                      <div class="line1">“</div>
                      <div class="text">柯米克GT车身多处运用了水晶切割的设计元素，还具备了同级最大的全景天窗，独特的车身双色设计，无不彰显时尚气息。</div>
                      <div class="line2">”</div>
                    </div>
                  </div>
                </div>
                <div class="right">
                  <div class="img">
                    <img alt="xxx" src="../../assets/skoda-drive/imgs/308.png" style="width: 100%;" />
                  </div>
                  <div class="content">
                    <div class="wrap">
                      <div class="title2">配置丰富，物超所值</div>
                      <div class="line1">“</div>
                      <div
                        class="text"
                      >柯米克GT配备了自动大灯、自动启停、自动空调，更有Smartlink智能手机映射系统，可以唤醒语音互动功能。顶配车型官方指导价是12.59万元，可谓性价比非常的高。</div>
                      <div class="line2">”</div>
                    </div>
                  </div>
                </div>
                <div style="clear: both;"></div>
              </div>
              <div style="clear: both;"></div>
            </div>
          </div>
        </div>
        <div class="section4" v-bind:style="{backgroundImage: 'url(' + sec4BackImg + ')'}">
          <div class="title">
            <div class="img">
              <img alt="xxx" src="../../assets/skoda-drive/imgs/401.png" style="width:100%" />
            </div>
          </div>
          <div class="navigation">
            <table style="width:100%;">
              <tr style="width:100%;">
                <td style="width:50%;">
                  <div class="nav1 clickStyle" @click="changeNav1()">
                    <div class="block1">
                      <div class="left">
                        <img
                          alt="xxx"
                          src="../../assets/skoda-drive/imgs/403.png"
                          style="width: 100%;"
                        />
                      </div>
                      <div class="right">柯迪亚克GT</div>
                      <div style="clear: both;"></div>
                    </div>
                    <div class="block2" v-if="sec4Nav==1">
                      <img alt="xxx" src="../../assets/skoda-drive/imgs/405.png" style="width:100%" />
                    </div>
                    <div class="block2" v-if="sec4Nav==2">
                      <img alt="xxx" src="../../assets/skoda-drive/imgs/406.png" style="width:100%" />
                    </div>
                  </div>
                </td>
                <td style="width:50%;">
                  <div class="nav2 clickStyle" @click="changeNav2()">
                    <div class="block1">
                      <div class="left">
                        <img
                          alt="xxx"
                          src="../../assets/skoda-drive/imgs/404.png"
                          style="width: 100%;"
                        />
                      </div>
                      <div class="right">柯米克GT</div>
                      <div style="clear: both;"></div>
                    </div>
                    <div class="block2" v-if="sec4Nav==2">
                      <img alt="xxx" src="../../assets/skoda-drive/imgs/405.png" style="width:100%" />
                    </div>
                    <div class="block2" v-if="sec4Nav==1">
                      <img alt="xxx" src="../../assets/skoda-drive/imgs/406.png" style="width:100%" />
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <div class="content content1" v-if="sec4Nav==1">
            <div class="left">
              <div class="contain">
                <div class="list">
                  <div class="item" id="item-select1" @click="sec4Click(1)">
                    <div class="title">
                      <img alt="xxx" src="../../assets/skoda-drive/imgs/3101.png" />
                    </div>
                    <div class="text">柯迪亚克GT 配备的2.0T的发动机最大特点是低转速大扭矩、高转速大功率，给驾驶者一种动力随叫随到并且源源不断的直观感受。</div>
                    <div class="jumpWei" @click="jumpWei(1)">查看原文></div>
                  </div>
                  <div class="item" id="item-select2" @click="sec4Click(2)">
                    <div class="title">
                      <img alt="xxx" src="../../assets/skoda-drive/imgs/3102.png" />
                    </div>
                    <div class="text">柯迪亚克GT提供了包括经济、运动、标准等在内的多达6种驾驶模式，可满足驾驶者不同路况下的驾驶体验。</div>
                    <div class="jumpWei" @click="jumpWei(2)">查看原文></div>
                  </div>
                  <div class="item" id="item-select3" @click="sec4Click(3)">
                    <div class="title">
                      <img alt="xxx" src="../../assets/skoda-drive/imgs/3103.png" />
                    </div>
                    <div
                      class="text"
                    >柯迪亚克GT是同价位同级别的车型中唯一一个拥有通风座椅的。 兼具轿跑SUV的外形、GT的澎湃动力，还配备了较多的同级领先的高科技配置，是一款适合年轻人、运动化的SUV。</div>
                    <div class="jumpWei" @click="jumpWei(3)">查看原文></div>
                  </div>
                  <div class="item" id="item-select4" @click="sec4Click(4)">
                    <div class="title">
                      <img alt="xxx" src="../../assets/skoda-drive/imgs/3104.png" />
                    </div>
                    <div class="text">柯迪亚克GT 搭载第三代EA888系列2.0T高功率发动机，匹配7速双离合变速箱，百公里加速仅需要6.4秒，领先同级别车型。</div>
                    <div class="jumpWei" @click="jumpWei(4)">查看原文></div>
                  </div>
                  <div class="item" id="item-select5" @click="sec4Click(5)">
                    <div class="title">
                      <img alt="xxx" src="../../assets/skoda-drive/imgs/3105.png" />
                    </div>
                    <div class="text">柯迪亚克GT拥有相当丰富的科技配置，全系标配的10.25英寸的液晶仪表，还可与中控屏幕进行双屏互动，领先同级别车型。</div>
                    <div class="jumpWei" @click="jumpWei(5)">查看原文></div>
                  </div>
                  <div class="item" id="item-select6" @click="sec4Click(6)">
                    <div class="title">
                      <img alt="xxx" src="../../assets/skoda-drive/imgs/3108.png" />
                    </div>
                    <div
                      class="text"
                    >柯迪亚克GT在副驾驶侧设计了上下分层的双开式手套箱、方向盘左侧还有放置油卡的卡槽，扶手箱和空调控制区域的下方也都有很大的储物空间，可以说车内空间的营造非常出色。</div>
                    <div class="jumpWei" @click="jumpWei(6)">查看原文></div>
                  </div>
                  <div class="item" id="item-select7" @click="sec4Click(7)">
                    <div class="title">
                      <img alt="xxx" src="../../assets/skoda-drive/imgs/3107.png" />
                    </div>
                    <div class="text">柯迪亚克GT动感的溜背造型相较常规的SUV视觉比例更为舒展，充满运动美学气息。</div>
                    <div class="jumpWei" @click="jumpWei(7)">查看原文></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="right">
              <div class="img">
                <img alt="xxx" :src="sec2RightPic" style="width: 100%;" />
              </div>
            </div>
            <div style="clear: both;"></div>
          </div>
          <div class="content content2" v-if="sec4Nav==2">
            <div class="left">
              <div class="contain">
                <div class="list">
                  <div class="item" id="item-select21" @click="sec4Click(21)">
                    <div class="title">
                      <img alt="xxx" src="../../assets/skoda-drive/imgs/3101.png" />
                    </div>
                    <div
                      class="text"
                    >柯米克GT拥有全景天窗、倒车影像、倒车雷达、语音控制、LED大灯、带过滤系统的自动空调等等12项标配，在同级别车型极具竞争力。</div>
                    <div class="jumpWei" @click="jumpWei(21)">查看原文></div>
                  </div>
                  <div class="item" id="item-select22" @click="sec4Click(22)">
                    <div class="title">
                      <img alt="xxx" src="../../assets/skoda-drive/imgs/3108.png" />
                    </div>
                    <div class="text">柯米克GT提供1.5L和1.2T两款发动机，搭配7速双离合变速箱，动力表现十分成熟。</div>
                    <div class="jumpWei" @click="jumpWei(22)">查看原文></div>
                  </div>
                  <div class="item" id="item-select23" @click="sec4Click(23)">
                    <div class="title">
                      <img alt="xxx" src="../../assets/skoda-drive/imgs/3109.png" />
                    </div>
                    <div class="text">柯米克GT全系标配中央8英寸镜面触控屏，内置斯柯达数字互联系统，契合时下年轻人对汽车智能化的需求。</div>
                    <div class="jumpWei" @click="jumpWei(23)">查看原文></div>
                  </div>
                  <div class="item" id="item-select24" @click="sec4Click(24)">
                    <div class="title">
                      <img alt="xxx" src="../../assets/skoda-drive/imgs/3110.png" />
                    </div>
                    <div class="text">当转速超过2000rpm，最大扭矩爆发后，柯米克GT将化身“小钢炮”，给你超强的驾驶体验。</div>
                    <div class="jumpWei" @click="jumpWei(24)">查看原文></div>
                  </div>
                  <div class="item" id="item-select25" @click="sec4Click(25)">
                    <div class="title">
                      <img alt="xxx" src="../../assets/skoda-drive/imgs/3104.png" />
                    </div>
                    <div class="text">柯米克GT的动力系统在普通版的基础上新增了一个1.2T+7DSG的版本，动力更强劲更有驾驶乐趣。</div>
                    <div class="jumpWei" @click="jumpWei(25)">查看原文></div>
                  </div>
                  <div class="item" id="item-select26" @click="sec4Click(26)">
                    <div class="title">
                      <img alt="xxx" src="../../assets/skoda-drive/imgs/3111.png" />
                    </div>
                    <div class="text">柯米克GT语音控制系统不仅能实现中文对话，甚至还可以直接英文对话，非常的贴心便利。</div>
                    <div class="jumpWei" @click="jumpWei(26)">查看原文></div>
                  </div>
                  <div class="item" id="item-select27" @click="sec4Click(27)">
                    <div class="title">
                      <img alt="xxx" src="../../assets/skoda-drive/imgs/3112.png" />
                    </div>
                    <div class="text">柯米克GT配备全自动空调，并且带PM2.5过滤空气净化系统，车内空气质量非常有保证。</div>
                    <div class="jumpWei" @click="jumpWei(27)">查看原文></div>
                  </div>
                  <div class="item" id="item-select28" @click="sec4Click(28)">
                    <div class="title">
                      <img alt="xxx" src="../../assets/skoda-drive/imgs/3107.png" />
                    </div>
                    <div class="text">柯米克GT采用水晶切割理念配合前卫设计元素，打造出现代个性的外观。</div>
                    <div class="jumpWei" @click="jumpWei(28)">查看原文></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="right">
              <div class="img">
                <img alt="xxx" :src="sec2RightPic" style="width: 100%;" />
              </div>
            </div>
            <div style="clear: both;"></div>
          </div>
          <div style="clear: both;"></div>
        </div>
        <div class="section5">
          <div class="title">
            <div class="img">
              <img alt="xxx" src="../../assets/skoda-drive/imgs/501.png" style="width:100%" />
            </div>
          </div>
          <div class="contain">
            <swiperSec5 id="swiper"></swiperSec5>
          </div>
        </div>
        <div class="section6">
          <popupSec3
            :showCover="showCoverSec3"
            :sec3Index="popupSec3Type"
            :closePopSec3="closePopSec3"
          ></popupSec3>
          <!-- <popupSec5 :showCover="showCoverSec5" :closePop="closePopSec5" :videoUrl="videoUrl"></popupSec5> -->
        </div>
      </div>
    </div>

    <SkodaDriveMobile v-if="isPhone"></SkodaDriveMobile>
    <Foot></Foot>
  </div>
</template>

<script>
import { getBrowserType, getBrowserHight } from "../../components/js/screen.js";
import SkodaDriveMobile from "./SkodaDriveMobile";
import Head from "../../components/header-index.vue";
import Foot from "../../components/footer-index.vue";
import swiperSec5 from "@/components/swiper/skoda-drive/SwiperSec5.vue";
import popupSec3 from "@/components/popup/skoda-drive/popupSec3.vue";
import popupSec5 from "@/components/popup/skoda-drive/popupSec5.vue";

export default {
  name: "Exhibition",
  components: {
    SkodaDriveMobile,
    Head,
    Foot,
    swiperSec5,
    popupSec3,
    popupSec5,
  },
  data() {
    return {
      isPhone: false,
      spotImg: require("../../assets/skoda-drive/imgs/201.jpg"),
      sec2RightPic: require("../../assets/skoda-drive/imgs/3101-1.jpg"),
      showCoverSec3: false,
      popupSec3Type: 1,
      sec4Nav: 1,
      showCoverSec5: false,
      videoUrl: "",
      sec4BackImg: require("../../assets/skoda-drive/imgs/402.png"),
    };
  },
  mounted: function () {
    // 判断是否手机
    this.getIsPhone();
    this.contain2Init();
    this.setTitle();
    this.sec4Click(1);
  },
  methods: {
    getIsPhone() {
      var userAgentInfo = navigator.userAgent;
      var Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      ];
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          this.isPhone = true;
        }
      }
    },
    setTitle() {
      document.title = "斯柯达GT双子星品评会";
    },
    contain2Init() {
      let index = 1;
      setInterval(() => {
        if (index > 3) {
          index = 1;
        }
        if (index == 1) {
          this.changeSpot1();
        } else if (index == 2) {
          this.changeSpot2();
        } else if (index == 3) {
          this.changeSpot3();
        }
        index++;
      }, 3000);
    },
    changeSpot1() {
      this.spotImg = require("../../assets/skoda-drive/imgs/201.jpg");
      document.getElementById("spot1").style.opacity = 1;
      document.getElementById("spot2").style.opacity = 0.4;
      document.getElementById("spot3").style.opacity = 0.4;
    },
    changeSpot2() {
      this.spotImg = require("../../assets/skoda-drive/imgs/202.jpg");
      document.getElementById("spot1").style.opacity = 0.4;
      document.getElementById("spot2").style.opacity = 1;
      document.getElementById("spot3").style.opacity = 0.4;
    },
    changeSpot3() {
      this.spotImg = require("../../assets/skoda-drive/imgs/203.jpg");
      document.getElementById("spot1").style.opacity = 0.4;
      document.getElementById("spot2").style.opacity = 0.4;
      document.getElementById("spot3").style.opacity = 1;
    },
    showPopSec3(type) {
      this.showCoverSec3 = true;
      this.popupSec3Type = type;
      this.pageStop();
    },
    closePopSec3() {
      this.showCoverSec3 = false;
      this.pageStart();
    },
    changeNav1() {
      this.sec4Nav = 1;
      setTimeout(() => {
        this.sec4Click(1);
      }, 10);
      this.sec4BackImg = require("../../assets/skoda-drive/imgs/402.png");
    },
    changeNav2() {
      this.sec4Nav = 2;
      setTimeout(() => {
        this.sec4Click(21);
      }, 10);
      this.sec4BackImg = require("../../assets/skoda-drive/imgs/402-2.png");
    },
    sec4Click(type) {
      if (type == 1) {
        this.sec2RightPic = require("../../assets/skoda-drive/imgs/3101-1.jpg");
      } else if (type == 2) {
        this.sec2RightPic = require("../../assets/skoda-drive/imgs/3102-1.jpg");
      } else if (type == 3) {
        this.sec2RightPic = require("../../assets/skoda-drive/imgs/3103-1.jpg");
      } else if (type == 4) {
        this.sec2RightPic = require("../../assets/skoda-drive/imgs/3104-1.jpg");
      } else if (type == 5) {
        this.sec2RightPic = require("../../assets/skoda-drive/imgs/3105-1.jpg");
      } else if (type == 6) {
        this.sec2RightPic = require("../../assets/skoda-drive/imgs/3108-1.jpg");
      } else if (type == 7) {
        this.sec2RightPic = require("../../assets/skoda-drive/imgs/3107-1.jpg");
      } else if (type == 101) {
        this.sec2RightPic = require("../../assets/skoda-drive/imgs/3113-01.jpg");
      } else if (type == 102) {
        this.sec2RightPic = require("../../assets/skoda-drive/imgs/3114-01.jpg");
      } else if (type == 103) {
        this.sec2RightPic = require("../../assets/skoda-drive/imgs/3115-01.jpg");
      } else if (type == 104) {
        this.sec2RightPic = require("../../assets/skoda-drive/imgs/3117-01.jpg");
      } else if (type == 21) {
        this.sec2RightPic = require("../../assets/skoda-drive/imgs/3101-2.jpg");
      } else if (type == 22) {
        this.sec2RightPic = require("../../assets/skoda-drive/imgs/3108-2.jpg");
      } else if (type == 23) {
        this.sec2RightPic = require("../../assets/skoda-drive/imgs/3109-2.jpg");
      } else if (type == 24) {
        this.sec2RightPic = require("../../assets/skoda-drive/imgs/3110-2.jpg");
      } else if (type == 25) {
        this.sec2RightPic = require("../../assets/skoda-drive/imgs/3104-2.jpg");
      } else if (type == 26) {
        this.sec2RightPic = require("../../assets/skoda-drive/imgs/3111-2.jpg");
      } else if (type == 27) {
        this.sec2RightPic = require("../../assets/skoda-drive/imgs/3112-2.jpg");
      } else if (type == 28) {
        this.sec2RightPic = require("../../assets/skoda-drive/imgs/3107-2.jpg");
      } else if (type == 201) {
        this.sec2RightPic = require("../../assets/skoda-drive/imgs/3113-02.jpg");
      } else if (type == 202) {
        this.sec2RightPic = require("../../assets/skoda-drive/imgs/3114-02.jpg");
      } else if (type == 203) {
        this.sec2RightPic = require("../../assets/skoda-drive/imgs/3116-02.jpg");
      } else if (type == 204) {
        this.sec2RightPic = require("../../assets/skoda-drive/imgs/3118-02.jpg");
      }
      // 先清除样式
      if (this.sec4Nav == 1) {
        this.clearNav1();
      } else if (this.sec4Nav == 2) {
        this.clearNav2();
      }
      // 再加上样式
      document.getElementById("item-select" + type + "").style.background =
        "rgba(255, 255, 255, 0.3)";
    },
    clearNav1() {
      for (var i = 1; i < 8; i++) {
        document.getElementById("item-select" + i + "").style.background = "";
      }
    },
    clearNav2() {
      for (var i = 21; i < 29; i++) {
        document.getElementById("item-select" + i + "").style.background = "";
      }
    },
    jumpWei(type) {
      if (type == 1) {
        window.open(
          "http://auto.eastday.com/a/n200601231642621.html",
          "_blank"
        );
      } else if (type == 2) {
        window.open(
          "https://mp.weixin.qq.com/s?__biz=MzUxMDg2ODQyMw==&mid=2247505255&idx=2&sn=67e6935f7dc9e7a93b9f9cb3ec345a33&chksm=f97efbcfce0972d93fe5d352f3645fce355478f74d7ef1f90c504389778c34fe8ae3c9ccafb3&mpshare=1&scene=1&srcid=&sharer_sharetime=1591187635824&sharer_shareid=21e3b955b097a21b3df20259f48ea0be&exportkey=AYg%2FQaGL4MUYfKyELb%2BHxqg%3D&pass_ticket=Ohe8tGg%2FuZXy6p7LGvX0XRBRiUm8e5QwjEV%2FpioR%2Bbl1JTHhnzXfF7jKz%2B8IR1dN#rd",
          "_blank"
        );
      } else if (type == 3) {
        window.open("http://inf.m.315che.com/n/2020_06/1976277/", "_blank");
      } else if (type == 4) {
        window.open(
          "https://mp.weixin.qq.com/s?__biz=MzU5MDc1OTEwMQ==&mid=2247486559&idx=2&sn=0613d9e2b82fcacfe2645003628a1703&chksm=fe38198dc94f909b0b1316d1e02935cd094b4bd42a57a56b4707bf629c1ea9a68b06798a8358&mpshare=1&scene=1&srcid=&sharer_sharetime=1591954398680&sharer_shareid=1ff7bb0b88c2ffedd896a4d4cb628594&exportkey=ATF0V%2FF1d4f28N75O9usZ3o%3D&pass_ticket=BXuCpiHb%2FnkwQkQ%2BsB5qDJfHMnvzt11aafE7jUU7twwpxGJYhRV5t%2FhWsKFM%2FB4e#rd",
          "_blank"
        );
      } else if (type == 5) {
        window.open("https://www.xincheping.com/cehua/132974.html", "_blank");
      } else if (type == 6) {
        window.open(
          "https://mp.weixin.qq.com/s?__biz=MzIwODEyNjUwNA==&mid=2649895666&idx=1&sn=7e6438e190ae06ec46a64a4b5903c2e9&chksm=8f0145b5b876cca3231fd5e3c5eca7591fafc827d0a42b304b2fe3c132ba3dcb8edce55bc35a&mpshare=1&scene=1&srcid=&sharer_sharetime=1593488614979&sharer_shareid=57a5d7a21a6ce22355c2ce53d7f32a57&exportkey=AXvlzUKml0yfuKbNuTxLCmc%3D&pass_ticket=4j8OiMvDgzILZWMZynUL9KbocwN7hyFRYfMbE9P6YO%2Fom9%2BL92Z%2BnTKFm95I%2FOaW&wx_header=0#rd",
          "_blank"
        );
      } else if (type == 7) {
        window.open(
          "https://web.shobserver.com/wx/detail.do?id=265388&from=singlemessage&isappinstalled=0",
          "_blank"
        );
      } else if (type == 101) {
        window.open(
          "https://www.pearvideo.com/video_1679853?st=1&from=singlemessage",
          "_blank"
        );
      } else if (type == 102) {
        window.open(
          "https://chejiahao.autohome.com.cn/info/6379732#pvareaid=6838848",
          "_blank"
        );
      } else if (type == 103) {
        window.open(
          "https://mp.weixin.qq.com/s?__biz=MjM5ODkyNDcwMw==&mid=2651687962&idx=1&sn=d4a722076510d5fce73e16aeed51d5d4&chksm=bd3a74ea8a4dfdfcfcd00e22a66ed40aed117b59367a8b9f0923e61595dbb0f6d20ce6495439&mpshare=1&scene=1&srcid=&sharer_sharetime=1593610846314&sharer_shareid=8727aead59d259cecd0c7aadfa2ce4a9&exportkey=AYcc8z%2BkcgS6Etjx7daKoFU%3D&pass_ticket=aYajMp2Wl%2Bj3pXrdCce6hM%2FmGsGWTV%2BcsLsbKdH8EqakIorFtiL2NkFeTV0m1JlT&wx_header=0#rd",
          "_blank"
        );
      } else if (type == 104) {
        window.open(
          "https://mp.weixin.qq.com/s?__biz=MzU4MDM2NTczOQ==&mid=2247484750&idx=1&sn=048874f16feb020d6826728c15371651&chksm=fd56b98aca21309c67fa7c0465ac4f3276945d9a2177801997cb3435abdbcf58c0ed02238c3d&mpshare=1&scene=1&srcid=&sharer_sharetime=1593662063518&sharer_shareid=8727aead59d259cecd0c7aadfa2ce4a9&exportkey=AXZxuV7bAxOqL2mmCJVGH3A%3D&pass_ticket=aYajMp2Wl%2Bj3pXrdCce6hM%2FmGsGWTV%2BcsLsbKdH8EqakIorFtiL2NkFeTV0m1JlT&wx_header=0#rd",
          "_blank"
        );
      } else if (type == 21) {
        window.open(
          "http://auto.eastday.com/a/n200603113042279.html",
          "_blank"
        );
      } else if (type == 22) {
        window.open(
          "https://mp.weixin.qq.com/s/U1R-Wx6Z9avOkPJzQd2XnA",
          "_blank"
        );
      } else if (type == 23) {
        window.open(
          "https://mp.weixin.qq.com/s?__biz=MzIzNzE3Mjk4Mg==&mid=2650641574&idx=1&sn=ccd47b72036b19e27d1ab44bc862bdfc&chksm=f0c5953fc7b21c294a394c424368c56f63d686ee0786efae9a244fd7071e8c9d1741343ca9d0&mpshare=1&scene=1&srcid=&sharer_sharetime=1592214221908&sharer_shareid=21e3b955b097a21b3df20259f48ea0be&exportkey=Adqbz4fHK5a%2BrMXyhduzwgw%3D&pass_ticket=BXuCpiHb%2FnkwQkQ%2BsB5qDJfHMnvzt11aafE7jUU7twwpxGJYhRV5t%2FhWsKFM%2FB4e#rd",
          "_blank"
        );
      } else if (type == 24) {
        window.open(
          "https://m.thepaper.cn/newsDetail_forward_7784380",
          "_blank"
        );
      } else if (type == 25) {
        window.open(
          "https://mp.weixin.qq.com/s/4MFyaysDGbKB4g9TtNJKag",
          "_blank"
        );
      } else if (type == 26) {
        window.open("https://www.toutiao.com/i6843301351594656263/", "_blank");
      } else if (type == 27) {
        window.open("https://www.tfauto.net/content/46415", "_blank");
      } else if (type == 28) {
        window.open(
          "https://web.shobserver.com/wx/detail.do?id=265388&from=singlemessage&isappinstalled=0",
          "_blank"
        );
      } else if (type == 201) {
        window.open(
          "https://www.pearvideo.com/video_1680987?st=1&from=singlemessage&isappinstalled=0",
          "_blank"
        );
      } else if (type == 202) {
        window.open(
          "http://www.che-shijie.com/news/2006/8932_1.shtml",
          "_blank"
        );
      } else if (type == 203) {
        window.open(
          "https://mp.weixin.qq.com/s?__biz=MjM5ODkyNDcwMw==&mid=2651687962&idx=1&sn=d4a722076510d5fce73e16aeed51d5d4&chksm=bd3a74ea8a4dfdfcfcd00e22a66ed40aed117b59367a8b9f0923e61595dbb0f6d20ce6495439&mpshare=1&scene=1&srcid=&sharer_sharetime=1593610846314&sharer_shareid=8727aead59d259cecd0c7aadfa2ce4a9&exportkey=AYcc8z%2BkcgS6Etjx7daKoFU%3D&pass_ticket=aYajMp2Wl%2Bj3pXrdCce6hM%2FmGsGWTV%2BcsLsbKdH8EqakIorFtiL2NkFeTV0m1JlT&wx_header=0#rd",
          "_blank"
        );
      } else if (type == 204) {
        window.open(
          "https://haokan.baidu.com/v?pd=bjh&vid=6295280492732915585&fr=bjhauthor&type=video",
          "_blank"
        );
      }
    },
    showPopSec5() {
      this.showCoverSec5 = true;
      this.pageStop();
    },
    closePopSec5() {
      this.showCoverSec5 = false;
      this.pageStart();
    },
    pageStop() {

    },
    pageStart() {

    },
  },
};
</script>

<style scoped>
@font-face {
  font-family: myCu;
  src: url("../../assets/font/FZYouHJW_Cu.TTF"),
    url("../../assets/font/FZYouHJW_Cu.eot");
  /* IE9+,可以是具体的实际链接 */
}
.drive {
  position: relative;
  width: 100%;
}
.pc {
  position: relative;
  width: 100%;
}
.clickStyle {
  cursor: pointer;
}

@media screen and (min-width: 1px) {
  .title2 {
    font-size: 20px;
    line-height: 30px;
    color: rgba(51, 51, 51, 1);
    font-weight: bold;
  }
  .text {
    font-size: 16px;
    line-height: 28px;
    color: rgba(51, 51, 51, 1);
    text-indent: 2em;
  }
  .section1 {
    position: relative;
    width: 100%;
  }

  .section2 {
    margin-top: 135px;
    padding-left: 160px;
    padding-right: 160px;
    padding-bottom: 120px;
  }
  .section2 .contain {
    position: relative;
    background: rgba(243, 243, 243, 1);
  }
  .section2 .contain .left {
    position: relative;
    float: left;
    width: 50%;
  }

  .section2 .contain .left .img {
    margin-left: 40px;
    margin-right: 40px;
    -webkit-transform: translate(0px, -64px);
    -moz-transform: translate(0px, -64px);
    transform: translate(0px, -64px);
  }
  .section2 .contain .right {
    position: relative;
    float: left;
    width: 50%;
  }
  .section2 .contain .right .title {
    font-size: 30px;
    line-height: 24px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    margin-top: 170px;
  }
  .section2 .contain .right .line {
    width: 60px;
    height: 0px;
    border-bottom: solid 4px black;
    margin-top: 27px;
  }
  .section2 .contain .right .text {
    font-size: 16px;
    line-height: 32px;
    color: rgba(51, 51, 51, 1);
    margin-top: 40px;
    text-indent: 0em;
  }
  .section2 .spot1 {
    position: absolute;
    width: 10px;
    height: 10px;
    background: white;
    border-radius: 100%;
    bottom: 20%;
    left: 45%;
    cursor: pointer;
  }
  .section2 .spot2 {
    position: absolute;
    width: 10px;
    height: 10px;
    background: white;
    border-radius: 100%;
    bottom: 20%;
    left: 50%;
    cursor: pointer;
  }
  .section2 .spot3 {
    position: absolute;
    width: 10px;
    height: 10px;
    background: white;
    border-radius: 100%;
    bottom: 20%;
    left: 55%;
    cursor: pointer;
  }

  .section3 {
    position: relative;
    background: rgba(243, 243, 243, 1);
    padding-left: 160px;
    padding-right: 160px;
    padding-top: 80px;
    padding-bottom: 80px;
  }
  .section3 .title .img {
    position: relative;
    width: 226px;
    left: 50%;
    margin-left: -113px;
    margin-bottom: 80px;
  }
  .section3 .contain {
    position: relative;
    width: 100%;
  }
  .section3 .contain .block1 {
    position: relative;
  }
  .section3 .contain .block1 .wrap {
    height: 144px;
  }

  .section3 .contain .block2 {
    margin-top: 40px;
  }
  .section3 .contain .block2 .wrap {
    height: 120px;
  }

  .section3 .contain .box1 .left {
    position: relative;
    float: left;
    width: 50%;
  }
  .section3 .contain .box1 .right {
    position: relative;
    float: left;
    width: 50%;
  }
  .section3 .contain .icon {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 80px;
    height: 80px;
    margin-left: -40px;
    margin-top: -40px;
  }
  .section3 .contain .box1 .content {
    position: absolute;
    top: 20%;
    margin-left: 80px;
    margin-right: 80px;
  }
  .section3 .contain .box1 .content .title {
    font-size: 20px;
    line-height: 30px;
    color: rgba(255, 255, 255, 1);
  }
  .section3 .contain .box1 .content .title2 {
    margin-top: 20px;
    color: rgba(255, 255, 255, 1);
  }
  .section3 .contain .box1 .content .text {
    margin-top: 20px;
    color: rgba(255, 255, 255, 1);
  }
  .section3 .contain .box2 {
    margin-top: 40px;
    position: relative;
  }
  .section3 .contain .box2 .left {
    position: relative;
    float: left;
    width: 49%;
    background: rgba(255, 255, 255, 1);
  }
  .section3 .contain .box2 .right {
    position: relative;
    float: right;
    width: 49%;
    background: rgba(255, 255, 255, 1);
  }
  .section3 .contain .box2 .content {
    padding: 50px;
  }

  .section3 .line1 {
    margin-top: 50px;
    margin-left: -15px;
    margin-bottom: -48px;
    font-family: myCu;
    font-size: 30px;
    color: rgba(255, 255, 255, 1);
  }
  .section3 .line2 {
    margin-right: -10px;
    position: relative;
    float: right;
    font-family: myCu;
    font-size: 30px;
    color: rgba(255, 255, 255, 1);
  }
  .section3 .box2 .line1 {
    margin-top: 10px;
    margin-bottom: -25px;
    color: rgba(212, 212, 212, 1);
  }
  .section3 .box2 .line2 {
    color: rgba(212, 212, 212, 1);
  }
  .section4 {
    position: relative;
    background-image: url("../../assets/skoda-drive/imgs/402.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding-top: 60px;
    padding-bottom: 148px;
  }
  .section4 .title .img {
    position: relative;
    width: 226px;
    left: 50%;
    margin-left: -113px;
  }
  .section4 .navigation {
    position: relative;
    margin-top: 90px;
  }
  .section4 .navigation .nav1 {
    position: relative;
    float: right;
  }
  .section4 .navigation .nav2 {
    position: relative;
    float: left;
    margin-left: 110px;
  }
  .section4 .navigation .left {
    position: relative;
    float: left;
    width: 182px;
    height: 67px;
  }
  .section4 .navigation .right {
    position: relative;
    float: left;
    font-size: 26px;
    line-height: 67px;
    color: rgba(255, 255, 255, 1);
    margin-left: 18px;
  }
  .section4 .navigation .block2 {
    width: 367px;
  }

  .section4 .content {
    position: relative;
    margin-top: 85px;
  }
  .section4 .content .left {
    position: relative;
    float: left;
    width: 50%;
  }
  .section4 .content .left .contain {
    height: 500px;
    margin-left: 160px;
    margin-right: 55px;
    overflow-y: auto;
  }
  /*.section4 .content .left .contain::-webkit-scrollbar {*/
  /*  !*滚动条整体样式*!*/
  /*  width: 4px; !*高宽分别对应横竖滚动条的尺寸*!*/
  /*  height: 1px;*/
  /*}*/
  /*.section4 .content1 .left .contain::-webkit-scrollbar-thumb {*/
  /*  !*滚动条里面小方块*!*/
  /*  border-radius: 10px;*/
  /*  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);*/
  /*  background: rgba(179, 1, 24, 1);*/
  /*}*/
  /*.section4 .content2 .left .contain::-webkit-scrollbar-thumb {*/
  /*  !*滚动条里面小方块*!*/
  /*  border-radius: 10px;*/
  /*  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);*/
  /*  background: rgba(213, 184, 22, 1);*/
  /*}*/
  /*.section4 .content .left .contain::-webkit-scrollbar-track {*/
  /*  !*滚动条里面轨道*!*/
  /*  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);*/
  /*  border-radius: 10px;*/
  /*  background: rgba(255, 255, 255, 1);*/
  /*}*/

  .section4 .content .left .contain .list {
    margin-right: 60px;
  }
  .section4 .content .left .contain .item {
    width: 100%;
    margin-bottom: 30px;
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    cursor: pointer;
  }
  .section4 .content .left .contain .item:hover {
    background: rgba(255, 255, 255, 0.3);
  }
  .section4 .content .left .contain .item .title {
    width: 118px;
  }
  .section4 .content .left .contain .item .text {
    margin-top: 10px;
    font-size: 16px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
    text-indent: 0em;
  }
  .section4 .content .right {
    position: relative;
    float: left;
    width: 50%;
  }
  .section4 .content .right .img {
    margin-right: 160px;
  }
  .section4 .jumpWei {
    margin-top: 10px;
    width: 120px;
    height: 30px;
    text-align: center;
    vertical-align: middle;
    border: 1px solid rgba(245, 245, 245, 1);
    font-size: 16px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
  }
  .section5 {
    position: relative;
    padding-top: 120px;
    padding-left: 160px;
    padding-right: 160px;
    padding-bottom: 150px;
  }
  .section5 .title .img {
    position: relative;
    width: 226px;
    left: 50%;
    margin-left: -113px;
    margin-bottom: 58px;
  }
  .section5 .contain {
    width: 100%;
  }
  .section5 .content {
    width: 100%;
    position: relative;
  }
  .section5 .left {
    position: relative;
    width: 50%;
    float: left;
  }
  .section5 .right {
    position: relative;
    width: 50%;
    float: left;
  }
}

@media screen and (min-width: 1px) and (max-width: 1300px) {
  .title2 {
    font-size: 14px;
    line-height: 20px;
    color: rgba(51, 51, 51, 1);
    font-weight: bold;
  }
  .text {
    font-size: 11px;
    line-height: 19px;
    color: rgba(51, 51, 51, 1);
    text-indent: 2em;
  }
  .section1 {
    position: relative;
    width: 100%;
  }

  .section2 {
    margin-top: 105px;
    padding-left: 108px;
    padding-right: 108px;
    padding-bottom: 80px;
  }
  .section2 .contain {
    position: relative;
    background: rgba(243, 243, 243, 1);
  }
  .section2 .contain .left {
    position: relative;
    float: left;
    width: 50%;
  }
  .section2 .contain .left .img {
    margin-left: 27px;
    margin-right: 27px;
    -webkit-transform: translate(0px, -43px);
    -moz-transform: translate(0px, -43px);
    transform: translate(0px, -43px);
  }
  .section2 .contain .right {
    position: relative;
    float: left;
    width: 50%;
  }
  .section2 .contain .right .title {
    font-size: 20px;
    line-height: 16px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    margin-top: 116px;
  }
  .section2 .contain .right .line {
    width: 54px;
    height: 0px;
    border-bottom: solid 3px black;
    margin-top: 18px;
  }
  .section2 .contain .right .text {
    font-size: 11px;
    line-height: 22px;
    color: rgba(51, 51, 51, 1);
    margin-top: 26px;
  }
  .section2 .spot1 {
    position: absolute;
    width: 10px;
    height: 10px;
    background: white;
    border-radius: 100%;
    bottom: 20%;
    left: 45%;
    cursor: pointer;
  }
  .section2 .spot2 {
    position: absolute;
    width: 10px;
    height: 10px;
    background: white;
    border-radius: 100%;
    bottom: 20%;
    left: 50%;
    cursor: pointer;
  }
  .section2 .spot3 {
    position: absolute;
    width: 10px;
    height: 10px;
    background: white;
    border-radius: 100%;
    bottom: 20%;
    left: 55%;
    cursor: pointer;
  }

  .section3 {
    position: relative;
    background: rgba(243, 243, 243, 1);
    padding-left: 108px;
    padding-right: 108px;
    padding-top: 53px;
    padding-bottom: 68px;
  }
  .section3 .title .img {
    position: relative;
    width: 154px;
    left: 50%;
    margin-left: -77px;
    margin-bottom: 55px;
  }
  .section3 .contain {
    position: relative;
    width: 100%;
  }
  .section3 .contain .block1 {
    position: relative;
  }
  .section3 .contain .block1 .wrap {
    height: 93px;
  }

  .section3 .contain .block2 {
    margin-top: 27px;
  }
  .section3 .contain .block2 .wrap {
    height: 93px;
  }

  .section3 .contain .box1 .left {
    position: relative;
    float: left;
    width: 50%;
  }
  .section3 .contain .box1 .right {
    position: relative;
    float: left;
    width: 50%;
  }
  .section3 .contain .icon {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 60px;
    height: 60px;
    margin-left: -30px;
    margin-top: -30px;
  }
  .section3 .contain .box1 .content {
    position: absolute;
    top: 20%;
    margin-left: 50px;
    margin-right: 50px;
  }
  .section3 .contain .box1 .content .title {
    font-size: 14px;
    line-height: 20px;
    color: rgba(255, 255, 255, 1);
  }
  .section3 .contain .box1 .content .title2 {
    margin-top: 15px;
    color: rgba(255, 255, 255, 1);
  }
  .section3 .contain .box1 .content .text {
    margin-top: 8px;
    color: rgba(255, 255, 255, 1);
  }
  .section3 .contain .box2 {
    margin-top: 27px;
    position: relative;
  }
  .section3 .contain .box2 .left {
    position: relative;
    float: left;
    width: 49%;
  }
  .section3 .contain .box2 .right {
    position: relative;
    float: right;
    width: 49%;
  }
  .section3 .contain .box2 .content {
    padding: 50px;
  }

  .section3 .line1 {
    margin-top: 45px;
    margin-left: -15px;
    margin-bottom: -25px;
    font-family: myCu;
    font-size: 19px;
    color: rgba(255, 255, 255, 1);
  }
  .section3 .line2 {
    margin-right: -10px;
    position: relative;
    margin-top: 8px;
    float: right;
    font-family: myCu;
    font-size: 19px;
    color: rgba(255, 255, 255, 1);
  }
  .section3 .box2 .line1 {
    margin-top: 10px;
    margin-bottom: -18px;
  }

  .section4 {
    position: relative;
    background-image: url("../../assets/skoda-drive/imgs/402.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding-top: 41px;
    padding-bottom: 60px;
  }
  .section4 .title .img {
    position: relative;
    width: 154px;
    left: 50%;
    margin-left: -77px;
  }
  .section4 .navigation {
    position: relative;
    margin-top: 40px;
  }
  .section4 .navigation .nav1 {
    position: relative;
    float: right;
  }
  .section4 .navigation .nav2 {
    position: relative;
    float: left;
    margin-left: 77px;
  }
  .section4 .navigation .left {
    position: relative;
    float: left;
    width: 123px;
    height: 45px;
  }
  .section4 .navigation .right {
    position: relative;
    float: left;
    font-size: 18px;
    line-height: 45px;
    color: rgba(255, 255, 255, 1);
    margin-left: 12px;
  }
  .section4 .navigation .block2 {
    width: 248px;
  }

  .section4 .content {
    position: relative;
    margin-top: 60px;
  }
  .section4 .content .left {
    position: relative;
    float: left;
    width: 50%;
  }
  .section4 .content .left .contain {
    height: 325px;
    margin-left: 110px;
    margin-right: 36px;
    overflow-y: auto;
  }
  /*.section4 .content .left .contain::-webkit-scrollbar {*/
  /*  !*滚动条整体样式*!*/
  /*  width: 4px; !*高宽分别对应横竖滚动条的尺寸*!*/
  /*  height: 1px;*/
  /*}*/
  /*.section4 .content .left .contain::-webkit-scrollbar-thumb {*/
  /*  !*滚动条里面小方块*!*/
  /*  border-radius: 10px;*/
  /*  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);*/
  /*  background: #535353;*/
  /*}*/
  /*.section4 .content .left .contain::-webkit-scrollbar-track {*/
  /*  !*滚动条里面轨道*!*/
  /*  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);*/
  /*  border-radius: 10px;*/
  /*  background: #ededed;*/
  /*}*/
  .section4 .content .left .contain .list {
    margin-right: 60px;
  }
  .section4 .content .left .contain .item {
    width: 100%;
    margin-bottom: 11px;
    padding-left: 5px;
    padding-top: 5px;
    padding-bottom: 5px;
    cursor: pointer;
  }
  .section4 .content .left .contain .item .title {
    width: 80px;
  }
  .section4 .content .left .contain .item .text {
    margin-top: 5px;
    font-size: 12px;
    line-height: 22px;
    color: rgba(255, 255, 255, 1);
  }
  .section4 .content .right {
    position: relative;
    float: left;
    width: 50%;
  }
  .section4 .content .right .img {
    margin-right: 110px;
  }
  .section4 .jumpWei {
    margin-top: 5px;
    width: 80px;
    height: 20px;
    text-align: center;
    vertical-align: middle;
    border: 1px solid rgba(245, 245, 245, 1);
    font-size: 12px;
    line-height: 22px;
    color: rgba(255, 255, 255, 1);
  }
  .section5 {
    position: relative;
    padding-top: 79px;
    padding-left: 108px;
    padding-right: 108px;
    padding-bottom: 134px;
  }
  .section5 .title .img {
    position: relative;
    width: 176px;
    left: 50%;
    margin-left: -88px;
    margin-bottom: 39px;
  }
  .section5 .contain {
    width: 100%;
  }
  .section5 .content {
    width: 100%;
    position: relative;
  }
  .section5 .left {
    position: relative;
    width: 50%;
    float: left;
  }
  .section5 .right {
    position: relative;
    width: 50%;
    float: left;
  }
}

@media screen and (min-width: 1301px) and (max-width: 1600px) {
  .title2 {
    font-size: 17px;
    line-height: 25px;
    color: rgba(51, 51, 51, 1);
    font-weight: bold;
  }
  .text {
    font-size: 13px;
    line-height: 23px;
    color: rgba(51, 51, 51, 1);
    text-indent: 2em;
  }
  .section1 {
    position: relative;
    width: 100%;
  }

  .section2 {
    margin-top: 129px;
    padding-left: 133px;
    padding-right: 133px;
    padding-bottom: 99px;
  }
  .section2 .contain {
    position: relative;
    background: rgba(243, 243, 243, 1);
  }
  .section2 .contain .left {
    position: relative;
    float: left;
    width: 50%;
  }
  .section2 .contain .left .img {
    margin-left: 33px;
    margin-right: 33px;
    -webkit-transform: translate(0px, -53px);
    -moz-transform: translate(0px, -53px);
    transform: translate(0px, -53px);
  }
  .section2 .contain .right {
    position: relative;
    float: left;
    width: 50%;
  }
  .section2 .contain .right .title {
    font-size: 25px;
    line-height: 20px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    margin-top: 143px;
  }
  .section2 .contain .right .line {
    width: 60px;
    height: 0px;
    border-bottom: solid 3px black;
    margin-top: 22px;
  }
  .section2 .contain .right .text {
    font-size: 13px;
    line-height: 27px;
    color: rgba(51, 51, 51, 1);
    margin-top: 33px;
  }
  .section2 .spot1 {
    position: absolute;
    width: 10px;
    height: 10px;
    background: white;
    border-radius: 100%;
    bottom: 20%;
    left: 45%;
    cursor: pointer;
  }
  .section2 .spot2 {
    position: absolute;
    width: 10px;
    height: 10px;
    background: white;
    border-radius: 100%;
    bottom: 20%;
    left: 50%;
    cursor: pointer;
  }
  .section2 .spot3 {
    position: absolute;
    width: 10px;
    height: 10px;
    background: white;
    border-radius: 100%;
    bottom: 20%;
    left: 55%;
    cursor: pointer;
  }

  .section3 {
    position: relative;
    background: rgba(243, 243, 243, 1);
    padding-left: 133px;
    padding-right: 133px;
    padding-top: 66px;
    padding-bottom: 80px;
  }
  .section3 .title .img {
    position: relative;
    width: 188px;
    left: 50%;
    margin-left: -94px;
    margin-bottom: 70px;
  }
  .section3 .contain {
    position: relative;
    width: 100%;
  }
  .section3 .contain .block1 {
    position: relative;
  }
  .section3 .contain .block1 .wrap {
    height: 124px;
  }

  .section3 .contain .block2 {
    margin-top: 33px;
  }
  .section3 .contain .block2 .wrap {
    height: 108px;
  }

  .section3 .contain .box1 .left {
    position: relative;
    float: left;
    width: 50%;
  }
  .section3 .contain .box1 .right {
    position: relative;
    float: left;
    width: 50%;
  }
  .section3 .contain .icon {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 70px;
    height: 70px;
    margin-left: -35px;
    margin-top: -35px;
  }
  .section3 .contain .box1 .content {
    position: absolute;
    top: 25%;
    margin-left: 58px;
    margin-right: 58px;
  }
  .section3 .contain .box1 .content .title {
    font-size: 17px;
    line-height: 25px;
    color: rgba(255, 255, 255, 1);
  }
  .section3 .contain .box1 .content .title2 {
    margin-top: 18px;
    color: rgba(255, 255, 255, 1);
  }
  .section3 .contain .box1 .content .text {
    margin-top: 8px;
    color: rgba(255, 255, 255, 1);
  }
  .section3 .contain .box2 {
    margin-top: 33px;
    position: relative;
  }
  .section3 .contain .box2 .left {
    position: relative;
    float: left;
    width: 49%;
  }
  .section3 .contain .box2 .right {
    position: relative;
    float: right;
    width: 49%;
  }
  .section3 .contain .box2 .content {
    padding: 50px;
  }

  .section3 .line1 {
    margin-top: 50px;
    margin-left: -15px;
    margin-bottom: -35px;
    font-family: myCu;
    font-size: 30px;
    color: rgba(255, 255, 255, 1);
  }
  .section3 .line2 {
    margin-right: -10px;
    position: relative;
    margin-top: 8px;
    float: right;
    font-family: myCu;
    font-size: 30px;
    color: rgba(255, 255, 255, 1);
  }
  .section3 .box2 .line1 {
    margin-top: 10px;
    margin-bottom: -28px;
  }

  .section4 {
    position: relative;
    background-image: url("../../assets/skoda-drive/imgs/402.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding-top: 50px;
    padding-bottom: 78px;
  }
  .section4 .title .img {
    position: relative;
    width: 188px;
    left: 50%;
    margin-left: -94px;
  }
  .section4 .navigation {
    position: relative;
    margin-top: 80px;
  }
  .section4 .navigation .nav1 {
    position: relative;
    float: right;
  }
  .section4 .navigation .nav2 {
    position: relative;
    float: left;
    margin-left: 90px;
  }
  .section4 .navigation .left {
    position: relative;
    float: left;
    width: 152px;
    height: 56px;
  }
  .section4 .navigation .right {
    position: relative;
    float: left;
    font-size: 22px;
    line-height: 56px;
    color: rgba(255, 255, 255, 1);
    margin-left: 18px;
  }
  .section4 .navigation .block2 {
    width: 306px;
  }

  .section4 .content {
    position: relative;
    margin-top: 78px;
  }
  .section4 .content .left {
    position: relative;
    float: left;
    width: 50%;
  }
  .section4 .content .left .contain {
    height: 430px;
    margin-left: 134px;
    margin-right: 44px;
    overflow-y: auto;
  }
  /*.section4 .content .left .contain::-webkit-scrollbar {*/
  /*  !*滚动条整体样式*!*/
  /*  width: 4px; !*高宽分别对应横竖滚动条的尺寸*!*/
  /*  height: 1px;*/
  /*}*/
  /*.section4 .content .left .contain::-webkit-scrollbar-thumb {*/
  /*  !*滚动条里面小方块*!*/
  /*  border-radius: 10px;*/
  /*  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);*/
  /*  background: #535353;*/
  /*}*/
  /*.section4 .content .left .contain::-webkit-scrollbar-track {*/
  /*  !*滚动条里面轨道*!*/
  /*  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);*/
  /*  border-radius: 10px;*/
  /*  background: #ededed;*/
  /*}*/
  .section4 .content .left .contain .list {
    margin-right: 44px;
  }
  .section4 .content .left .contain .item {
    width: 100%;
    margin-bottom: 14px;
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    cursor: pointer;
  }
  .section4 .content .left .contain .item .title {
    width: 80px;
  }
  .section4 .content .left .contain .item .text {
    margin-top: 10px;
    font-size: 13px;
    line-height: 27px;
    color: rgba(255, 255, 255, 1);
  }
  .section4 .content .right {
    position: relative;
    float: left;
    width: 50%;
  }
  .section4 .content .right .img {
    margin-right: 133px;
  }
  .section4 .jumpWei {
    margin-top: 10px;
    width: 100px;
    height: 25px;
    text-align: center;
    vertical-align: middle;
    border: 1px solid rgba(245, 245, 245, 1);
    font-size: 13px;
    line-height: 27px;
    color: rgba(255, 255, 255, 1);
  }
  .section5 {
    position: relative;
    padding-top: 98px;
    padding-left: 133px;
    padding-right: 133px;
    padding-bottom: 150px;
  }
  .section5 .title .img {
    position: relative;
    width: 218px;
    left: 50%;
    margin-left: -109px;
    margin-bottom: 48px;
  }
  .section5 .contain {
    width: 100%;
  }
  .section5 .content {
    width: 100%;
    position: relative;
  }
  .section5 .left {
    position: relative;
    width: 50%;
    float: left;
  }
  .section5 .right {
    position: relative;
    width: 50%;
    float: left;
  }
}
</style>